<template>
  <div>
    <div v-if="showPassword">
      <Password @save="load" :tries="passwordTries" :showBack="true" />
    </div>
    <div
      v-else
      :class="this.view.grid ? 'screen' : 'screen flex'"
      :style="`min-height: ${windowHeight}px`"
    >
      <div class="screen__open-header" v-if="view.grid && showHeader">
        <div
          class="image-upload"
          @click="
            fullscreen(null, { name: 'Upload', url: qrCodeImageUploadUrl })
          "
        >
          <qrcode-vue
            :value="qrCodeImageUploadUrl"
            class="qrCode"
            :size="qrCodeSize"
            :renderAs="'svg'"
            level="L"
          ></qrcode-vue>
          <span>Upload</span>
        </div>
        <span v-if="windowWidth >= 620" class="name">{{ pinwall.name }}</span>
        <div
          v-if="windowWidth >= 352"
          class="comment"
          @click="fullscreen(null, { name: 'Comment', url: qrCodeCommentUrl })"
        >
          <qrcode-vue
            class="qrCode"
            :value="qrCodeCommentUrl"
            :size="qrCodeSize"
            :renderAs="'svg'"
            level="L"
          ></qrcode-vue>
          <span>Comment</span>
        </div>
        <b-button
          @click.prevent.stop="showHeader = !showHeader"
          class="close"
          type="is-text"
          icon-left="chevron-up"
        ></b-button>
      </div>
      <div class="screen__close-header" v-if="view.grid && !showHeader">
        <b-button
          @click.prevent.stop="showHeader = !showHeader"
          class="open"
          type="is-text"
          icon-left="chevron-down"
        ></b-button>
      </div>
      <Grid
        v-if="view.grid"
        :editable="false"
        :posts="pinwall.posts"
        :mode="'screen'"
        @openComments="openComments"
        @fullscreen="fullscreen"
        @ended="$refs.controls.next()"
      ></Grid>

      <Loop v-if="view.loop" :posts="pinwall.posts"></Loop>

      <b-modal
        v-if="view.grid"
        class="fullscreen"
        :active.sync="isFullscreenModalActive"
      >
        <div v-if="qrCode">
          <qrcode-vue
            :value="qrCode.url"
            class="qrCode"
            :size="windowWidth * 0.8 < 500 ? windowWidth * 0.8 : 500"
            :renderAs="'svg'"
            level="L"
          ></qrcode-vue>
          <span>{{ qrCode.name }}</span>
        </div>
        <Post v-if="post" :mode="'fullscreen'" :post="post" />
      </b-modal>

      <b-modal :active.sync="isCommentModalActive">
        <Comment :postId="post ? post.id : ''" :pinwallId="pinwall.id" />
      </b-modal>
      <Controls v-if="view.grid" ref="controls" :posts="pinwall.posts" />
    </div>
    <div v-if="isLoading" class="loading-container">
      <b-loading
        :is-full-page="false"
        :active.sync="isLoading"
        :can-cancel="true"
      ></b-loading>
    </div>
  </div>
</template>

<script>
import Grid from "@/components/pinwall/Grid";
import Password from "@/components/core/Password";
import Post from "../components/pinwall/Post";
import Comment from "../components/pinwall/Comment";
import Controls from "@/components/core/Controls";
import Loop from "../components/core/Loop";
import { mapActions, mapGetters, mapMutations } from "vuex";
import QrcodeVue from "qrcode.vue";
import { getScrollY } from "../mixins/getScrollY";

export default {
  name: "screen",
  components: {
    Grid,
    Password,
    Post,
    Comment,
    Loop,
    QrcodeVue,
    Controls
  },
  data: () => {
    return {
      sort: "",
      showPassword: false,
      showHeader: true,
      isFullscreenModalActive: false,
      isFullScreen: false,
      isCommentModalActive: false,
      isSocketSubscribed: false,
      initialLoad: true,
      subscribeId: "",
      password: "",
      isLoading: false,
      isFullPage: true,
      qrCodeImageUploadUrl: "",
      qrCodeCommentUrl: "",
      qrCodeSize: 150,
      qrCode: null,
      size: null,
      post: null,
      passwordTries: 0,
      view: {
        grid: false,
        loop: false
      }
    };
  },
  mixins: [getScrollY],
  computed: {
    ...mapGetters(["pinwall", "storedPinwalls", "viewHeight", "tenant"])
  },
  watch: {
    windowWidth: "changePostPosition",
    getScrollY: "handleScroll"
  },
  methods: {
    ...mapActions(["loadPinwall"]),
    ...mapMutations(["setStoredPinwall", "setViewHeight"]),
    fullscreen(post, qrCode) {
      if (post) {
        this.post = post;
        this.qrCode = null;
      }
      if (qrCode) {
        this.qrCode = qrCode;
        this.post = null;
      }

      this.isFullscreenModalActive = true;
    },
    setStyle() {
      return `width: ${this.windowWidth / 2}px`;
    },
    openComments(post) {
      this.post = post;
      this.isCommentModalActive = true;
    },
    changePostPosition() {
      if (
        window.fullScreen ||
        (window.innerWidth == screen.width &&
          window.innerHeight == screen.height)
      ) {
        this.isFullScreen = true;
        return;
      } else if (this.isFullScreen) {
        this.isFullScreen = false;
      }

      const that = this;
      clearTimeout(this.doit);
      this.doit = setTimeout(function() {
        that.load();
      }, 500);
    },
    sortPosts(value) {
      this.initialLoad = true;
      this.sort = value;
      this.load();
    },
    load(password, socketEmit) {
      const params = this.$route.params;
      this.tenantId = params.tenant || "pinwall";
      this.space = params.space || null;
      this.pinwallId = params.pinwallId || null;
      this.password = password || this.password;
      this.isLoading = true;
      this.loadPinwall({
        tenant: this.tenantId,
        space: this.space,
        pinwallId: this.pinwallId,
        password: this.password,
        sort: this.sort,
        view: this.view.loop ? "loop" : null,
        socketEmit: socketEmit,
        windowWidth: this.windowWidth,
        initialLoad: this.initialLoad
      })
        .then(() => {
          this.isLoading = false;
          this.showPassword = false;
          this.initialLoad = false;
          this.subscribeId =
            this.pinwall.id + (this.pinwall.password || this.password || "");

          if (!this.isSocketSubscribed) {
            this.sockets.subscribe(this.subscribeId, data => {
              if (
                data.sort === this.sort &&
                data.view === "" &&
                data.windowWidth >= this.windowWidth - 150 &&
                data.windowWidth <= this.windowWidth + 150
              ) {
                this.setPosts(data.postList);
              } else {
                this.initialLoad = true;
                this.load(null, true);
              }
            });
            this.isSocketSubscribed = true;
          }

          const baseUrl = `https:${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
            this.tenantId
          }/${this.space}/${this.pinwallId}`;

          this.qrCodeImageUploadUrl = `${baseUrl}/add?id=${this.pinwall.id}&${
            this.pinwall.options.private
              ? "password=" + this.pinwall.password
              : ""
          }`;
          this.qrCodeCommentUrl = `${baseUrl}/comment?${
            this.pinwall.options.private
              ? "password=" + this.pinwall.password
              : ""
          }`;

          this.setStoredPinwall({
            tenant: this.tenantId,
            space: this.space,
            pinwallId: this.pinwallId,
            password: this.password,
            userId: this.user ? this.user.id : ""
          });
        })
        .catch(() => {
          this.showPassword = true;
          this.passwordTries = this.passwordTries + 1;
        });
    },
    handleScroll() {
      const scrollYPosition = window.scrollY + window.innerHeight;

      var additionalHeight = (this.viewHeight / 100) * 20;
      var wantedHeight =
        additionalHeight <= 540
          ? this.viewHeight + additionalHeight
          : this.viewHeight + 540;

      if (
        scrollYPosition >= wantedHeight &&
        this.pinwall.posts.length < this.pinwall.postsCount &&
        !this.isLoading
      ) {
        this.setViewHeight(scrollYPosition);
        this.load();
      }
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.setViewHeight(0);
    const params = this.$route.params;
    this.storedPinwall = null;
    this.tenantId = params.tenant || "pinwall";
    this.space = params.space || null;
    this.pinwallId = params.pinwallId || null;
    this.userId = this.user ? this.user.id : "";
    this.sort = this.$route.query.sort;

    if (this.storedPinwalls) {
      this.storedPinwall = this.storedPinwalls.find(item => {
        return (
          item.tenant === this.tenantId &&
          item.space === this.space &&
          item.pinwallId === this.pinwallId &&
          item.userId === this.userId
        );
      });
    }

    this.password =
      this.storedPinwall && this.storedPinwall.password
        ? this.storedPinwall.password
        : this.$route.query.password;

    const mode = this.$route.query.mode || "";
    switch (mode) {
      case "loop":
        this.view.loop = true;
        this.sort = this.sort || "old";
        break;
      case "grid":
        this.view.grid = true;
        this.sort = this.sort || "presentation";
        break;
      default:
        this.view.grid = true;
        this.sort = this.sort || "presentation";
        break;
    }
    this.load();
  }
};
</script>
